import { render, staticRenderFns } from "./beat-drift-3.vue?vue&type=template&id=446bce01&scoped=true&"
import script from "./beat-drift-3.vue?vue&type=script&lang=js&"
export * from "./beat-drift-3.vue?vue&type=script&lang=js&"
import style0 from "./beat-drift-3.vue?vue&type=style&index=0&id=446bce01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446bce01",
  null
  
)

export default component.exports